module.exports = __webpack_public_path__ + "media/精工工艺--大堂.cef198e4.mp4";